<template>
  <div class="line-toolbar-wrapper">
    <!-- line color -->
    <ColorSetting
      :key="componentKey"
      :currentColor="currentColor"
      @changeColor="onChangeLineColor"
      @stopChangingColor="onStopChangeLineColor"
      class="color-setting"
      v-tooltip="$i18nPresenter.t('Line color')"
    />
    <AnimationToolbar />
    <!-- line weight -->
    <!-- <WeightSetting @changeWeight="onChangeWeight" /> -->
    <!-- line dash -->
    <!-- <DashSetting @changeDash="onChangeDash" /> -->
    <!-- line start -->

    <!-- line end -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from '@/eventBus'
import ColorSetting from './editors/ColorSetting.vue'
import util from '@/util'
import eventCategories from '@/constant/eventCategories'
import AnimationToolbar from '@/components-v2/presentation-editor/middle/AnimationToolbar.vue'

export default {
  components: {
    AnimationToolbar,
    ColorSetting,
  },
  data() {
    return {
      componentKey: (new Date()).getTime(),
    }
  },
  computed: {
    ...mapState({
      selectingBlocks: (state) => state.selectingBlocks,
    }),
    currentColor() {
      if (this.selectingBlocks && this.selectingBlocks.length > 0) {
        return this.selectingBlocks[0].content.lC
      }
      return '#4af'
    },
  },
  watch: {
    selectingBlocks: {
      handler() {
        this.componentKey = (new Date()).getTime()
      },
      immediate: true,
    },
  },
  methods: {
    onChangeLineColor(color) {
      const newBlocks = this.selectingBlocks.map((block) => {
        if (block.type !== 'Line') return block
        return {
          ...block,
          content: {
            ...block.content,
            lC: color,
          },
        }
      })
      EventBus.$emit('update-line-blocks', newBlocks)
    },
    onStopChangeLineColor(color) {
      util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Update line', 'color', color)
    },
    onChangeWeight() {

    },
    onChangeDash() {

    },
  },
}
</script>

<style lang="scss" scoped>
.line-toolbar-wrapper {
  @apply  h-full flex items-center justify-start;
  @apply bg-base-0;
}
.color-setting {
  @apply mr-3 ml-3;
}
</style>
